<template>
    <v-navigation-drawer app v-model="value">

        <n-header/>
        <n-content></n-content>

    </v-navigation-drawer>
</template>

<script>
import {default as NHeader} from './NavDrawer/Header';
import {default as NContent} from './NavDrawer/Content';

export default {
    components: {
        NHeader,
        NContent,
    },
    props: {
        drawer: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        value: {
            get() {
                return this.drawer;
            },
            set(value) {
                this.$emit("update:drawer", value);
            },
        },
    },
};
</script>

<style scoped lang="scss">
.v-navigation-drawer {
    background-color: #364150 !important;
}
</style>
